
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Component Libraries`}</h3>
    <ul>
      <li parentName="ul">{`Added a `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react/?path=/story/components-drawer--with-different-variants"
        }}>{`Navigation Rail`}</a>{` component for React.`}</li>
      <li parentName="ul">{`Added new React Native components for `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react-native/?path=/info/components-documentation--mobile-stepper"
        }}>{`Mobile Stepper`}</a>{` and `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/react-native/?path=/info/components-documentation--user-menu"
        }}>{`User Menu`}</a>{`.`}</li>
      <li parentName="ul">{`Updated components to respond to system font size.`}</li>
    </ul>
    <h3>{`Themes`}</h3>
    <ul>
      <li parentName="ul">{`Overhauled PX Blue dark theme for `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@pxblue/angular-themes"
        }}>{`Angular`}</a>{` and `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@pxblue/react-themes"
        }}>{`React`}</a>{`.`}</li>
      <li parentName="ul">{`New dark themes for `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@pxblue/react-native-themes"
        }}>{`React Native`}</a>{`.`}</li>
      <li parentName="ul">{`Updated `}<a parentName="li" {...{
          "href": "/style/themes"
        }}>{`Theme Documentation`}</a>{` to reflect theme changes.`}</li>
    </ul>
    <h3>{`Component Sticker Sheet`}</h3>
    <ul>
      <li parentName="ul">{`Figma `}<a parentName="li" {...{
          "href": "https://www.figma.com/community/file/852558784352181868"
        }}>{`Component Sticker Sheet`}</a>{` updated to reflect latest theme changes.`}</li>
      <li parentName="ul">{`Updated iconography and typography.`}</li>
      <li parentName="ul">{`New components for pager, steppers, tables, and more.`}</li>
    </ul>
    <h3>{`Design Patterns`}</h3>
    <ul>
      <li parentName="ul">{`New design pattern for `}<a parentName="li" {...{
          "href": "/patterns/account-menu"
        }}>{`Account Menu`}</a>{`.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/community/file/926189711301522231"
        }}>{`Design Pattern Library`}</a>{` in Figma updated with examples of all of our `}<a parentName="li" {...{
          "href": "/patterns"
        }}>{`Design Patterns`}</a>{`.`}</li>
    </ul>
    <h3>{`Reusable Workflows`}</h3>
    <ul>
      <li parentName="ul">{`Added the ability to customize various aspects of the Authentication workflows, including custom registration fields.`}</li>
    </ul>
    <h3>{`PX Blue CLI`}</h3>
    <ul>
      <li parentName="ul">{`You can now kick start your projects with templates (Blank, Routing, or Authentication) for Angular and React Native projects.`}</li>
      <li parentName="ul">{`The first PX Blue `}<a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=CESJ9BKLWco"
        }}>{`training video`}</a>{` is now available and walks you through how to use the PX Blue CLI to start your next project.`}</li>
    </ul>
    <h3>{`Miscellaneous`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes & performance updates`}</li>
      <li parentName="ul">{`New documentation site holiday themes`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;